// extracted by mini-css-extract-plugin
export default {"component":"OtherDirectories_component__QzVsD","title":"OtherDirectories_title__obwLA","link":"OtherDirectories_link__5gK5E","linkIcon":"OtherDirectories_linkIcon__ooV6U"};